// extracted by mini-css-extract-plugin
export var desc = "style-module--desc--869a6";
export var inner = "style-module--inner--c8aa8";
export var reg = "style-module--reg--ed317";
export var undertext = "style-module--undertext--d6927";
export var widget = "style-module--widget--4f48f";